import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useLogout, useCurrentUser } from "utils/hooks";
import { fetchOrganizationUsersAction } from "store/actions/organizations";

const useFetchOrganizationUsers = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchOrganizationUsers = async (organizationId: string | null) => {
    if (!organizationId) {
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getAllOrganizationUsers(organizationId: "${organizationId}") {
                uuid
                firstName
                lastName
                email
                slug
                status
                role
                invitingTherapist
                icon
                color
                type
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_organization_members",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        dispatch(
          fetchOrganizationUsersAction(resData.data.getAllOrganizationUsers)
        );
      } else {
        if (resData.errors[0].message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else if (res.status === 403) {
          // User doesn't have permission to view organization members
          // This is expected for non-owners, so we don't throw an error
          console.log(
            "User doesn't have permission to view organization members"
          );
          // Clear any existing organization users data
          dispatch(fetchOrganizationUsersAction([]));
        } else {
          // Throw the error so it can be caught by the calling hook
          throw new Error(resData.errors[0].message);
        }
      }
    } catch (error) {
      // Handle network errors or other unexpected errors
      console.error("Error fetching organization users:", error);
      // Clear any existing organization users data
      dispatch(fetchOrganizationUsersAction([]));
    }
  };

  return {
    fetchOrganizationUsers,
  };
};

export default useFetchOrganizationUsers;
